/* eslint-disable comma-dangle */
/*
  Babel will yell at you in your command line if you have dangling commas in the `import` statements
  in this file. If you don't have them ESLint will get mad at you, so we need to disable the rule.
*/

export default [
  {
    routeProps: {
      path: '/',
      exact: true,
    },
    loader: () =>
      import(
        /* webpackChunkName: "Homepage" */
        './containers/routes/Homepage/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/Homepage/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/Homepage/index.js')],
  },
  {
    routeProps: {
      path: '/search/:term',
    },
    loader: () =>
      import(
        /* webpackChunkName: "Search" */
        './containers/routes/Search/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/Search/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/Search/index.js')],
  },
  {
    routeProps: {
      path: '/premium-benefits',
    },
    loader: () =>
      import(
        /* webpackChunkName: "PremiumLanding" */
        './containers/routes/PremiumLanding/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/PremiumLanding/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/PremiumLanding/index.js')],
  },
  {
    routeProps: {
      path: '/contests/:contest/:region/:period/entries/:entry',
    },
    loader: () =>
      import(
        /* webpackChunkName: "ContestEntryContainer" */
        './containers/routes/ContestEntryContainer/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/ContestEntryContainer/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/ContestEntryContainer/index.js')],
  },
  {
    routeProps: {
      path: '/contests/:contest/:region/:period/entries/',
    },
    loader: () =>
      import(
        /* webpackChunkName: "ContestEntries" */
        './containers/routes/ContestEntries/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/ContestEntries/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/ContestEntries/index.js')],
  },
  {
    routeProps: {
      path: '/contests/:contest/:region/:period/details/',
    },
    loader: () =>
      import(
        /* webpackChunkName: "ContestDetails" */
        './containers/routes/ContestDetails/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/ContestDetails/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/ContestDetails/index.js')],
  },
  {
    routeProps: {
      path: '/contests/:contest/:region/:period/submit/',
    },
    loader: () =>
      import(
        /* webpackChunkName: "ContestSubmit" */
        './containers/routes/ContestSubmit/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/ContestSubmit/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/ContestSubmit/index.js')],
  },
  {
    routeProps: {
      path: '/contests/:contest/:region/:period/',
    },
    loader: () =>
      import(
        /* webpackChunkName: "ContestLanding" */
        './containers/routes/ContestLanding/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/ContestLanding/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/ContestLanding/index.js')],
  },
  {
    routeProps: {
      path: '/surf-cams',
    },
    loader: () =>
      import(
        /* webpackChunkName: "SurfCams" */
        './containers/routes/SurfCams/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/SurfCams/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/SurfCams/index.js')],
  },
  {
    routeProps: {
      path: '*',
      status: 404,
    },
    loader: () =>
      import(
        /* webpackChunkName: "NotFound" */
        './containers/routes/NotFound/index.js'
      ),
    loading: () => null,
    modules: ['./containers/routes/NotFound/index.js'],
    webpack: () => [require.resolveWeak('./containers/routes/NotFound/index.js')],
  },
];
